import * as services from '@services/index';
import { IPatients } from '@models/patients';
import { COVID_ORDER_STATUS_TYPE } from '@/schemas/order';
import {
  ICouponListQuery,
  ICouponListData,
  ICouponCard,
  COUPON_TYPE
} from '@schemas/coupon';
import { IDoctorTelReseve } from '@/schemas/doctor';

import { IYodaSelectedImage } from '@/schemas/common';

interface State {
  patientInfo: IPatients; // 问诊下单选中的就诊人
}
interface IGetCouponParams {
  query: ICouponListQuery;
  getMore: boolean;
}

const order = {
  state: {
    patientInfo: {} as IPatients,
    orderInfo: {
      content: '',
      images: [] as string[],
      beenHospital: '',
      contactNum: '',
      doctorServiceTime: {} as IDoctorTelReseve
    },
    covid19: {
      type: '',
      currentTab: COVID_ORDER_STATUS_TYPE.ALL,
      scrollY: 0,
      pageSize: 10
    },
    couponSelect: {
      originPrice: 0, // 咨询服务原价
      currentSelectedCoupon: -1, // 当前选中的优惠券
      finalPrice: 0, // 优惠券使用后最终价格
      couponList: [] as ICouponCard[], // 优惠券选择数组
      lastMark: false, // 是否是优惠券的最后一页
      pageNum: 1,
      haveInit: false // 优惠券数据已经初始化
    }
  },

  reducers: {
    // 在这里写纯函数来改变 state
    updatePatientInfo(state: State, payload: IPatients | undefined) {
      return {
        ...state,
        patientInfo: payload
      };
    },
    updateState(state, payload) {
      return {
        ...state,
        ...payload
      };
    },
    updateImages(state, payload: IYodaSelectedImage[]) {
      if (state.orderInfo.images >= 8) return state;

      const newImgs = payload.map(
        (item) => `data:image/${item.fileType};base64, ${item.base64}`
      );

      if (newImgs) {
        return {
          ...state,
          orderInfo: {
            ...state.orderInfo,
            images: [...state.orderInfo.images, ...newImgs]
          }
        };
      }

      return state;
    },
    updateImagesBase64(state, payload: string[]) {
      return {
        ...state,
        orderInfo: {
          ...state.orderInfo,
          images: payload
        }
      };
    },
    UpdateCovid19State(state, payload) {
      return {
        ...state,
        covid19: {
          ...state.covid19,
          ...payload
        }
      };
    },
    // 更新优惠券相关数据
    updateCouponSelect(state, payload) {
      return {
        ...state,
        couponSelect: {
          ...state.couponSelect,
          ...payload
        }
      };
    },
    // 更新最终优惠价格
    updateFinalPrice(state, payload) {
      const price = payload
        ? (Math.round(state.couponSelect.originPrice * 100) -
            Number(payload ?? 0)) /
          100
        : state.couponSelect.originPrice;
      return {
        ...state,
        couponSelect: {
          ...state.couponSelect,
          finalPrice: price > 0 ? price : 0
        }
      };
    }
  },

  effects: (dispatch) => ({
    // 获取优惠券信息
    async getCouponData({ query, getMore }: IGetCouponParams, state) {
      if (!getMore && state?.order?.couponSelect?.haveInit) return;
      try {
        const res: ICouponListData = await services.coupon.getCouponData(query);
        this.updateCouponSelect({
          couponList: getMore
            ? state?.order?.couponSelect?.couponList?.concat(res?.list || [])
            : res?.list || [],
          lastMark: res.lastMark,
          pageNum: res.pageNum
        });
        // 首次请求到优惠券数据更新最终价格
        if (!getMore) {
          this.updateCouponSelect({
            haveInit: true,
            currentSelectedCoupon: res?.list?.[0]?.orderAvailable ? 0 : -1
          });
          this.updateFinalPrice(
            !res?.list?.[0]?.orderAvailable
              ? 0
              : res?.list?.[0]?.type === COUPON_TYPE.FREE_COUPON
              ? Math.round(state?.order?.couponSelect?.originPrice * 100)
              : res?.list?.[0]?.couponValue
          );
        }
      } catch (e) {
        !getMore && this.updateFinalPrice();
        // console.log('拉取患者信息错误', e);
      }
    }
  })
};

export default order;
